import React from 'react';
import Header from './header';
import Termos from './termos';
import { connect } from 'react-redux';
import { changeState, logout } from '../actions/AppActions';
import { DEBUG, URL } from '../variables';
import ChangeCamModal from './changeCamModal';
import ConexaoProcesso from './conexao_processo';
import NotProcesso from './NotProcesso';
// import io from 'socket.io-client';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import ProcessoUser from './ProcessoUser';
import moment from 'moment-timezone';
import JoditEditor from 'jodit-react';
import FaceMesh from './FaceMesh';
import { CandidateLoader, CandidateValidationNotice } from './CandidateUi';
import { getLanguageTexts, getSelectedLanguage } from '../language';

// import * as faceapi from 'face-api.js'
function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
const OtherRoute = ({ component: Component, path_name, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      <Redirect to={{ pathname: path_name, state: { from: props.location } }} />
    }
  />
);
class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      // redirect:'/not_processo',
      other_window: false,
      invalid: false,
      mobile: true,
      screenExtended: false,
      hide: false,
      processos: [],
      show_proccess: false,
      face_detected:false,
      left_movement:false,
      right_movement:false,
      audio_detected:false,
      center_movement:false,
      show_face_mesh:false,
      loading_media:true,
      multipleface_detected:false,
      show_btn_change:false,
      msgErro:''
    }
    this.videoRef = React.createRef();
    this.screenRef = React.createRef();

    this.imageRef = React.createRef();
    this.canvas = React.createRef();
    this.user_id = uuidv4();
    this.audioContext = {};
    this.first = true;
    this.timer_audio_high = Date.now() / 1000
    this.streamRef = React.createRef();
    this.left_count=0;
    this.frame_count=0;
    this.right_count=0;
    this.center_count=0;
    this.up_count=0;
    this.down_count=0;
    this.middle_count=0;
    this.face_count=0;
    this.multiple_faces_count=0;
    this.last_face_recognize=null;
    this.last_audio_detected=null;
    this.last_audio_variation=null;
    // this.videoRef=null;
  }
  logout() {
    localStorage.removeItem('token');
    // this.setState({redirect:true,path:'/'});
    this.props.logout();
  }

  draw_peer() {
    try {
      if (this.audioContext['context'].state != 'running') {
        this.audioContext['context'].resume();
      }
      if (
        this.props.stream != null
      ) {


        // var drawVisual = requestAnimationFrame(()=>draw_peer(id));
        this.audioContext['analyser'].getByteTimeDomainData(this.audioContext['dataArray']);

        var sliceWidth = 300 * 1.0 / this.audioContext['bufferLength'];
        var x = 0;
        let max = 0;
        // console.log('draw peer')

        for (var i = 0; i < this.audioContext['bufferLength']; i++) {
          var v = this.audioContext['dataArray'][i] / 128.0;
          // console.log('audio',((v - 0.93) * 100))
          if(this.last_audio_variation!=(v - 0.93) * 100){
            this.last_audio_detected=moment();
            this.last_audio_variation=(v - 0.93) * 100;
          }

          if (((v - 0.93) * 100) >= 20 && (Date.now() / 1000) - this.timer_audio_high > 60 && this.props.processo.simulado == false
            && this.props.andamento == true
          ) {
            this.timer_audio_high = Date.now() / 1000;
            
            this.salvar_log_screen_extended('audio_high');
          }
          else if(((v - 0.93) * 100) >= 10 && this.props.processo.face_validation==true && this.state.audio_detected==false && this.props.processo.simulado == false){
            console.log('ta alto2',((v - 0.93) * 100))
            this.state.audio_detected=true;
            this.setState({audio_detected:true})
          }
          // else{
          //     bar1[0].hidden=true;
          //     bar2[0].hidden=true;
          //     bar3[0].hidden=true;
          // }
          // if((v-1)>0)
          //     bar_peer.style.clipPath='circle(40%)';
          // else
          //     bar_peer.style.clipPath='circle(30%)';



        }
        this.clearPeer =  setTimeout(() => {
          this.draw_peer()
        }, 300);
      }
      else {
        this.first = true;
      }
    }
    catch (e) {
      console.log(e)
    }


  };


  async componentDidMount() {
    this.props.changeState({ loading_home: true });
    this.event_storage = ((e) => {
      console.log(e)
      if (e.key == "openpages") {
        // Listen if anybody else is opening the same page!
        localStorage.page_available = Date.now();
      }
      if (e.key == "page_available") {
        this.setState({ other_window: true });
      }
    }).bind(this)
    localStorage.openpages = Date.now();
    window.addEventListener('storage', this.event_storage, false);
    try {
      this.myWorker = new SharedWorker('check.js');
      this.myWorker.port.start();
      this.myWorker.port.postMessage(this.user_id);

      this.myWorker.port.onmessage = e => {
        // console.log(e.data);
        // if (e.data == true) {
        //   this.get_user();
        // }
        // else {
        //   this.setState({ other_window: true });
        // }
      };
      this.time_get_user = setTimeout(() => {
        this.get_user();
      }, 1000);
      this.setState({ mobile: false });

    }
    catch (e) {
      this.setState({ mobile: true });
      this.time_get_user = setTimeout(() => {
        this.get_user();
      }, 1000);

    }

    // if ('getScreenDetails' in window) {
    //   // The Multi-Screen Window Placement API is supported.
    //   this.screenCheck=((event) => {
    //     // Handle screens change.
    //     console.log(event)
    //   }).bind(this);
    //   this.screenDetails = await window.getScreenDetails();
    //   this.screenDetails.addEventListener('screenschange', this.screenCheck);
    // }




  }

 
 

  async get_user() {
    const MODEL_URL = '/models'

  
    fetch(`${URL}api/external/get_user/`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',

        'Authorization': `Bearer ${this.props.token}`,
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();

          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n';
            else
              erro += errors[i];
          }
          console.log(erro)
          this.setState({msgErro:erro})
          this.props.changeState({
            faculdade: resp.faculdade,
            loading_home: false,
          });
          return;
          // console.log(erro);

          // // this.props.mudarLoadingHome(false);
          // this.time_get_user = setTimeout(() => {
          //   this.get_user();
          // }, 5000);
        }
        else {
        
            this.props.changeState({
              faculdade: resp.faculdade,
              processo: resp.processo,
              user: resp.user,
              sala: resp.sala,
              loading_home: false,
              processo_resultado: resp.processo_resultado
            });
          
          

          if (resp.processos?.length > 1) {
            if (this.state.processos.length == 0) {
              this.setState({ processos: resp.processos, show_proccess: true });
            }
          }
        }




      } catch (err) {
        console.log(err);
        // this.props.mudarLoadingHome(false);
        this.time_get_user = setTimeout(() => {
          this.get_user();
        }, 5000);

      }

    })
      .catch((err) => {
        console.log(err);
        // this.props.mudarLoadingHome(false);
        this.time_get_user = setTimeout(() => {
          this.get_user();
        }, 5000);
      });
  }

  select_proccess(processo_id) {

    fetch(`${URL}api/external/select_proccess`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',

        'Authorization': `Bearer ${this.props.token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        processo_id: processo_id
      })
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n';
            else
              erro += errors[i];
          }
          console.log(erro);

          // this.props.mudarLoadingHome(false);
          this.time_select_proccess = setTimeout(() => {
            this.select_proccess(processo_id);
          }, 5000);
        }
        else {
          if (resp.status == false) {
            this.setState({ processos: [] }, () => {
              this.get_user();
            });
          }
          else {
            this.get_user();
          }
        }
      } catch (err) {
        console.log(err);
        this.time_select_proccess = setTimeout(() => {
          this.select_proccess(processo_id);
        }, 5000);
      }

    })
      .catch((err) => {
        console.log(err);
        this.time_select_proccess = setTimeout(() => {
          this.select_proccess(processo_id);
        }, 5000);
      });
  }

  salvar_log_permission(msg) {
    fetch(`${URL}api/external/salvar_log?screen=permission&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}&msg=${msg}&external=1`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',

        'Authorization': `Bearer ${this.props.token}`,
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
        }
        else {

        }
      } catch (err) {
        console.log(err);

      }

    })
      .catch((err) => {
        console.log(err);

      });
  }

  componentDidUpdate(props) {
    if (this.props.stream != null && this.videoRef.current != null && (props.stream == null || this.props.stream.id != props.stream.id)) {
      this.videoRef.current.srcObject = this.props.stream
      this.streamRef.current = this.props.stream
      this.setState({show_face_mesh:true});
      try {
        this.audioContext['context'] = new AudioContext();
        this.audioContext['analyser'] = this.audioContext['context'].createAnalyser();
        this.audioContext['frequencyData'] = null;
        this.audioContext['source'] = this.audioContext['context'].createMediaStreamSource(this.props.stream);
        this.audioContext['source'].connect(this.audioContext['analyser']);
        this.audioContext['gainNode'] = this.audioContext['context'].createGain();
        this.audioContext['gainNode'].gain.value = 0.1; // setting it to 10%
        this.audioContext['gainNode'].connect(this.audioContext['context'].destination);
        // analyser.connect(context.destination);

        this.audioContext['context'].resume()
        this.audioContext['analyser'].fftSize = 32;
        this.audioContext['bufferLength'] = this.audioContext['analyser'].frequencyBinCount;
        this.audioContext['dataArray'] = new Uint8Array(this.audioContext['bufferLength']);
        this.audioContext['analyser'].getByteTimeDomainData(this.audioContext['dataArray']);

        if (this.first == true) {
          this.first = false;
          clearTimeout(this.clearPeer);
          this.draw_peer();
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (this.props.stream_screen != null && this.videoRef.current != null && (props.stream_screen == null || this.props.stream_screen.id != props.stream_screen.id)) {
      this.screenRef.current.srcObject = this.props.stream_screen
    }
    if (this.props.stream != null && props.stream?.id != this.props.stream?.id) {
      console.log('inactive stream')
      this.props.stream.oninactive = () => {
        console.log('inactive2')

        this.stream_screen = null;
        if (this.unmont_ == false) {
          // this.setState({ loading_camera: false, msg: 'Compartilhe a tela cheia para avançar', show_screen_sharing: true, show_screen: false, show_aceitar: false });
        }
        else {
        }
        if (this.props.show_call == true) {
          this.props.socket.emit('exit_call', { aluno_id: this.props.user.id, processo_id: this.props.processo.id, id: this.props.user.id })
        }
        if (this.props.stream_screen != null) {
          this.props.stream_screen.getVideoTracks()[0].onended = function () { };
          this.props.stream_screen.getTracks().map((track) => track.stop());
        }

        this.props.changeState({ stream: null, stream_screen: null })
        // if(this.props.processo?.screen_sharing==true){

        // }
        this.salvar_log_permission('Cancelou permissão de câmera');

        this.props.history.push({
          pathname: '/',
          search: '?error=Compartilhamento de Vídeo/Áudio foi cancelado pelo candidato. Compartilhe novamente para realizar a avaliação'
        });
        console.log('teste2')
      }
    }
    if (this.props.stream_screen != null && props.stream_screen != this.props.stream_screen) {
      console.log('inactive screen')

      this.props.stream_screen.getVideoTracks()[0].onended = () => {
        console.log('inactive3')
        if (this.props.show_call == true) {
          this.props.socket.emit('exit_call', { aluno_id: this.props.user.id, processo_id: this.props.processo.id, id: this.props.user.id })
        }
        if (this.props.stream != null) {
          console.log('finalizado stream5')

          this.props.stream.oninactive = function () { };
          this.props.stream.getTracks().map((track) => track.stop());
        }


        // if (this.unmont_ == false) {
        //   this.setState({ loading_camera: false, msg: 'Compartilhe a tela cheia para avançar', show_screen_sharing: true, show_screen: false, show_aceitar: false });
        // }
        // else {
        // }
        let active = this.props.stream?.active;
        this.props.changeState({ stream: null, stream_screen: null })
        this.salvar_log_permission('Cancelou permissão de compartilhamento de tela');

        this.props.history.push({
          pathname: '/',
          search: '?error=Compartilhamento de Vídeo/Áudio ou Tela foi cancelado pelo candidato. Compartilhe novamente para realizar a avaliação'
        });
      }


      console.log('teste3')
    }

  }


  componentWillUnmount() {
    clearTimeout(this.time_get_user);
    clearTimeout(this.time_select_proccess);

    if (this.videoRef.current != null) {
      this.videoRef.current.srcObject = null;
    }
    if (this.screenRef.current != null) {
      this.screenRef.current.srcObject = null;
    }
    if (this.worker != null) {
      // this.worker.terminate();
      this.props.changeState({ worker: null });
    }
    clearInterval(this.screenExtended)

     try {

      if (this.props.stream != null) {
        console.log('finalizado stream4')

        this.props.stream.oninactive = function () { }
        this.props.stream.getTracks().map((track) => {
          track.stop();
        })
      }
    }
    catch (e) {
      console.log(e)
    }
    try {

      if (this.props.stream_screen != null) {
        console.log('finalizado')
        this.props.stream_screen.oninactive = function () { }
        this.props.stream_screen.getVideoTracks()[0].onended = function () { }

        this.props.stream_screen.getTracks().map((track) => {

          track.stop();
        })
      }
    }
    catch (e) {
      console.log(e)
    }

    this.props.changeState({ stream: null, stream_screen: null });

    if (this.event_storage != null) {
      window.removeEventListener('storage', this.event_storage, false);
    }
    // if(this.screenDetails!=null){
    //   this.screenDetails.removeEventListener('screenschange', this.screenCheck);
    // }
  }

  render() {
    const t = getLanguageTexts(getSelectedLanguage());
    console.log(this.state.show_face_mesh)
    console.log(this.state.mobile)
    return (
      <div className="external-camera-page">
        {this.state.other_window == false && <div>

          {/* {this.state.redirect == true && <Redirect to={this.state.path} />} */}
          <canvas ref={this.canvas} id="background-canvas" style={{ position: 'absolute', top: '-500px', left: '-500px' }}></canvas>

          <img ref={this.imageRef} hidden />
          <div id="wrapper">
            {(this.props.show_call == false || (this.props.show_call == true && this.props.user.accessibility == true && this.props.user.type_supervisor != 'none' && this.props.processo.is_interview == false)) && <Header />}
            {this.state.msgErro=='' && this.props.loading_home == false  && <div className={(this.props.processo == null || this.props.processo.mobile == undefined ) ? "d-none d-sm-block" : "d-block d-sm-block"}>
              <div id="content-page" className="external-camera-main" style={{ marginLeft: 0 }}>
                <div className="content">
                  

                  <div className="external-camera-shell">
                    <div className="external-camera-title-row">
                      <span className="candidate-auth-kicker">{t.external_camera_access}</span>
                      <h1>{this.props.faculdade.name}</h1>
                      <p>{t.external_camera_page_hint}</p>
                    </div>
                    {/* {this.props.processo != null &&
                   } */}

                    {this.state.show_face_mesh && this.props.processo.face_validation==true && true==false && this.props.stream!=null && <FaceMesh onFaceDetect={(value) => {
                      this.face_count++;
                      if(value==true){
                        this.last_face_recognize=moment();
                      }
                      if (this.state.face_detected != value) {
                        this.state.face_detected = value;
                        this.multiple_faces_count=0;
                        this.setState({ face_detected: value,multipleface_detected:false });
                      }
                    }}
                    onMultipleFaceDetect={(value) => {
                      if(value==true){
                        this.multiface_count++;
                      }
                      if (this.state.multipleface_detected != value) {
                        this.state.multipleface_detected = value;
                        this.setState({ multipleface_detected: value,face_detected:value==true?false:this.state.face_detected });
                      }
                      if(value==true){
                        this.multiple_faces_count+=1;

                        if(this.last_warning_multiple_face==null || Math.abs(moment().diff(this.last_warning_multiple_face,'minutes'))>=1){

                          if(this.multiple_faces_count>=5 && this.props.socket!=null && this.props.processo.simulado==false && this.props.sala && this.props.processo){
                            this.multiple_faces_count=0;
                            this.last_warning_multiple_face=moment();
                            this.props.socket.emit('send_warning_movement',{sala_id:this.props.sala.id,processo_id:this.props.processo.id,aluno_id:this.props.user.id,multiple:true})
                          }
                        }
                      }

                    }}
                      incrementTotalFrames={() => {
                        this.frame_count++;
                      }}
                      onRightDirection={(value) => {
                        this.right_count++;
                        if (this.state.face_detected == true && this.state.right_movement != value && this.state.center_movement == true) {
                          this.state.right_movement = value;
                          this.setState({ right_movement: value });
                        }
                      }}
                      onLeftDirection={(value) => {
                        this.left_count++;
                        if (this.state.face_detected == true && this.state.left_movement != value
                          && this.state.right_movement == true
                        ) {
                          this.state.left_movement = value;
                          this.setState({ left_movement: value });
                        }
                      }}
                      onCenterDirection={(value) => {
                        this.center_count++;
                        if (this.state.face_detected == true && this.state.center_movement != value
                        ) {
                          this.state.center_movement = value;
                          this.setState({ center_movement: value });
                        }
                      }}
                      onUpDirection={(value)=>{
                        this.up_count++;
                      }}
                      onMiddleDirection={(value)=>{
                        this.middle_count++;
                      }}
                      onDownDirection={(value)=>{
                        this.down_count++;
                      }}
                      onLoadMedia={(e) => {
                        if(this.state.loading_media!=e){
                          this.setState({ loading_media: e })
                        }
                      }}
                      videoRef={() => this.videoRef} stream={this.props.stream} />}
                    <Switch>
                      {this.props.processo != null && <>
                        <Route exact path={`${this.props.match.url}`} render={(props2) => <Termos 
                        mobile={this.state.mobile}
                        video={(e) => {
                          return this.videoRef
                        }} 
                        changeStateParent={(data)=>this.setState(data)}
                        show_face_mesh={this.state.show_face_mesh}
                        loading_media={this.state.loading_media}
                        face_detected={this.state.face_detected}
                        multipleface_detected={this.state.multipleface_detected}
                        left_movement={this.state.left_movement}
                        right_movement={this.state.right_movement}
                        audio_detected={this.state.audio_detected}
                        center_movement={this.state.center_movement}
                        stream_ref={this.streamRef}
                        selectProccess={(processo_id) => {
                          this.props.changeState({ loading_home: true });
                          this.setState({ show_proccess: false });
                          this.select_proccess(processo_id);
                        }} setShowProccess={(e) => this.setState({ show_proccess: e })} processos={this.state.processos} show_proccess={this.state.show_proccess} {...props2} />} />
                        <Route exact path={`${this.props.match.url}processo`} render={(props2) => { return (<ProcessoUser getValues={()=>{
                          let data={
                            left_count:this.left_count,
                            frame_count:this.frame_count,
                            right_count:this.right_count,
                            center_count:this.center_count,
                            up_count:this.up_count,
                            down_count:this.down_count,
                            middle_count:this.middle_count,
                            face_count:this.face_count,
                            multiface_count:this.multiface_count,
                          }
                          this.left_count=0;
                          this.frame_count=0;
                          this.right_count=0;
                          this.center_count=0;
                          this.up_count=0;
                          this.down_count=0;
                          this.middle_count=0;
                          this.face_count=0;
                          this.multiface_count=0;
                          return data;
                        }} 
                        changeStateParent={(data)=>this.setState(data)}
                        face_detected={this.state.face_detected}
                        multipleface_detected={this.state.multipleface_detected}
                        left_movement={this.state.left_movement}
                        right_movement={this.state.right_movement}
                        audio_detected={this.state.audio_detected}
                        center_movement={this.state.center_movement}
                        loading_media={this.state.loading_media}

                        getLastDetection={()=>{
                          return {
                            last_audio_detected:this.last_audio_detected,
                            last_face_recognize:this.last_face_recognize,
                          }
                        }}

                        videoRef={() => this.videoRef} {...props2} />) }} />
                      </>}


                      {this.props.processo == null && <Route exact path={`${this.props.match.url}`} component={(props2) => <NotProcesso {...props2} />} />}

                      <OtherRoute path="*" path_name='/' />

                    </Switch>

                    {<div hidden={this.props.show_call == true && (this.props.user.accessibility == false || this.props.user.type_supervisor == 'none' || this.props.processo.is_interview == true)}>
                    {this.props.processo != null && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo_resultado != null && this.props.processo_resultado.status != 'F' && this.props.stream != null && <div className='d-block' >
                     
                      {this.state.loading_media==false && this.state.show_btn_change==true &&
                      this.props.processo.face_validation==true &&
                      <button hidden={this.state.hide==true} onClick={() => this.props.changeState({ change_cam_modal: true })} className="btn btn-primary btn-sm candidate-primary-action" data-id="content_question" data-toggle="modal"
                        data-target="#change_camera">
                        <i className="mdi mdi-camera-switch" aria-hidden="true"></i> {t.change_camera}
                      </button>}
                    </div>}
                    <div hidden={this.state.hide == true || this.props.stream==null} className='d-sm-block' >
                      <div hidden={this.state.hide == true || this.props.stream==null} className="external-camera-card external-camera-hidden-recorder">
                        <video src={this.props.stream} autoPlay style={{ transform: 'rotateY(180deg)' }} id="video_oficial" ref={this.videoRef} muted>
                        </video>
                      </div>
                      {this.state.loading_media==false && this.state.show_btn_change==true && this.props.processo.face_validation==true && <ChangeCamModal changeStateParent={(data)=>this.setState(data)} />}

                    </div>
                    {this.props.processo != null && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo_resultado != null && this.props.processo_resultado.status != 'F' && this.props.stream != null && <ConexaoProcesso />}

                  </div>}
                    {/* { this.props.children } */}
                    {/* {this.props.processo == null &&
                    <NotProcesso />} */}
                  </div>
                </div>
              </div>
            </div>}
            {this.props.loading_home == true && <div className="candidate-auth-loading">
              <CandidateLoader title={t.loading_data} description={t.external_camera_loading_hint} />
            </div>}
            
            

          </div>
          {this.state.msgErro!='' && this.props.loading_home == false && <div className="candidate-screen-center">
            <div className="external-camera-overlay-card">
              <CandidateValidationNotice tone="danger" title={t.cannot_continue}>
                {this.state.msgErro}
              </CandidateValidationNotice>
              <div className="external-camera-actions">
                <a className="btn btn-secondary btn-lg" onClick={()=>{
                  window?.history?.back();
                }}><i className="mdi mdi-arrow-left" aria-hidden="true"></i> {t.back}</a>
              </div>
            </div>

          </div>

          }
          

          {(this.props.screenExtended == true) && <div id='container-s12319dasa' className="external-camera-overlay">
            <div className="external-camera-overlay-card">
              <h4>{t.two_screens_blocked}</h4>
            </div>
          </div>}
        </div>}

        {(this.state.other_window == true) && <div className="external-camera-overlay">
          <div className="external-camera-overlay-card">
            <h4>{t.other_window_open}</h4>
          </div>
        </div>}

        <div id='ping_time' style={{ position: 'fixed', bottom: 10, left: 10, fontSize: 13, color: 'green' }}>

        </div>

      </div >

    );
  }


}

const mapsStateToProps = (state) => (
  {
    faculdade: state.AppReducer.faculdade,
    token: state.AppReducer.token,
    loading_home: state.AppReducer.loading_home,
    stream: state.AppReducer.stream,
    stream_screen: state.AppReducer.stream_screen,

    processo: state.AppReducer.processo,
    user: state.AppReducer.user,

    processo_resultado: state.AppReducer.processo_resultado,
    screenExtended: state.AppReducer.screenExtended,
    andamento: state.AppReducer.andamento,
    show_call: state.AppReducer.show_call,
    socket: state.AppReducer.socket,
    sala: state.AppReducer.sala,
  }
);

export default connect(mapsStateToProps, { changeState, logout })(Home);
